/* eslint-disable react/no-unused-state */
import React, { Component, PropTypes } from 'react'
import classnames from 'classnames'
import { format, parse } from 'date-fns'
// import moment from 'moment'
import Table from 'components/Table'
import Heading from 'components/Heading'
import Card from 'components/Card'
import Button from 'components/Button'
import Dialog from 'components/Dialog'
import constants from 'constants'

const styles = Object.assign(
  {},
  require('../PartnerPlanList.scss'),
  { columns: require('../../columns.scss') },
  { table: require('components/Table/Table.scss') },
)

const headerStyles = classnames(styles.table.unSortable)

class PartnerPlanRatingsUploadList extends Component {
  static propTypes = {
    deleteDocument: PropTypes.func.isRequired,
    header: PropTypes.string,
    partnerPlanRatingsUpload: PropTypes.object.isRequired,
    partnerPlanRatingsUploadItems: PropTypes.instanceOf(Array),
  }
  static defaultProps = {
    partnerPlanRatingsUploadItems: {},
    header: '',
  }
  constructor(props) {
    super(props)
    this.state = {
      confirmDeleteDialogOpen: false,
      submit: false,
      documentSelected: '',
    }
  }
  _openConfirmDeleteDialog = (itemId) => {
    this.setState({ confirmDeleteDialogOpen: true })
    this.setState({ documentSelected: itemId })
  }

  _closeConfirmDeleteDialog = () => {
    this.setState({ confirmDeleteDialogOpen: false })
  }

  _saveConfirmDeleteDialog = () => {
    this.setState({
      confirmDeleteDialogOpen: false,
      submit: true,
    })
    this.props.deleteDocument(this.state.documentSelected)
  }

  _statusColor = (status) => {
    switch (status) {
      case constants.PARTNERPLAN.RATINGSUPLOAD.PENDING:
        return styles.columns.description
      case constants.PARTNERPLAN.RATINGSUPLOAD.COMPLETED:
        return styles.statusSuccess
      case constants.PARTNERPLAN.RATINGSUPLOAD.ERROR:
        return styles.statusError
      case constants.PARTNERPLAN.RATINGSUPLOAD.COMPLETEDWITHERRORS:
      case constants.PARTNERPLAN.RATINGSUPLOAD.COMPLETEDWITHWARNINGS:
        return styles.statusWarnings
      default:
        return styles.columns.description
    }
  }

  renderCols = () => {
    return (
      <tr>
        <th className={(styles.columns.description, headerStyles)}>
          Name
        </th>
        <th className={(styles.columns.status, headerStyles)}>Status</th>
        <th className={(styles.columns.created, headerStyles)}>Created</th>
        <th className={(styles.columns.view, headerStyles)} />
      </tr>
    )
  }

  renderData = () => {
    return this.props.partnerPlanRatingsUploadItems.length ? (
      this.props.partnerPlanRatingsUploadItems.map(rating => (
        <tr className={styles.base} key={rating.itemId}>
          <td className={styles.columns.description}>
            <a href={rating.path} rel="noopener noreferrer" target="_blank" title={rating.documentName}>{rating.documentName}</a>
          </td>
          <td className={this._statusColor(rating.status)}>{rating.status}</td>
          <td>{(rating.created ? format(parse(rating.created, constants.DATE_FORMAT.SPO_FORMAT, new Date()), constants.DATE_FORMAT.STANDARD_AU_FULLMONTH_TIME) : '')}</td>
          <td>{rating.status === constants.PARTNERPLAN.RATINGSUPLOAD.PENDING &&
            <Button
              onClick={() => {
                this._openConfirmDeleteDialog(rating.itemId)
              }}
              type="flat"
            >
              DELETE
            </Button>}
            {(rating.status === constants.PARTNERPLAN.RATINGSUPLOAD.COMPLETED
            || String(rating.status) === constants.PARTNERPLAN.RATINGSUPLOAD.ERROR
            || String(rating.status) === constants.PARTNERPLAN.RATINGSUPLOAD.COMPLETEDWITHERRORS
            || String(rating.status) === constants.PARTNERPLAN.RATINGSUPLOAD.COMPLETEDWITHWARNINGS) &&
            <a href={rating.logPath} rel="noopener noreferrer" target="_blank">UPLOAD REPORT</a>}
          </td>
        </tr>
      ))
    ) : (
      <tr>
        <td colSpan={5}>
          <div className={styles.noPartnerPlans}>
            <div>No matching records found</div>
          </div>
        </td>
      </tr>
    )
  }

  render() {
    const confirmDeleteProps = {
      actions: [
        { label: 'CANCEL', onClick: this._closeConfirmDeleteDialog },
        { label: 'DELETE', onClick: this._saveConfirmDeleteDialog },
      ],
      title: 'Are you sure you want to delete this document?',
      active: this.state.confirmDeleteDialogOpen,
      onClose: this._closeConfirmDeleteDialog,
    }
    return (
      <div>
        <Heading noTopPadding>{this.props.header}</Heading>
        <Card noPadding>
          <Table>
            <thead>{this.renderCols()}</thead>
            <tbody>{this.renderData()}</tbody>
          </Table>
        </Card>
        <Dialog {...confirmDeleteProps}>
          You will be not able to bring this back once deleted.
        </Dialog>
      </div>
    )
  }
}

export default PartnerPlanRatingsUploadList



// WEBPACK FOOTER //
// ./src/views/PartnerPlans/components/PartnerPlan/PartnerPlanRatingsUploadList.js